/**
 * Returns Material Table rows with active column filters and search applied.
 */
export function getMaterialTableExportData(tableRef) {
    if (
        !tableRef ||
        !tableRef.current ||
        !tableRef.current.dataManager
    ) {
        return [];
    }

    const dataManager = tableRef.current.dataManager;
    dataManager.getRenderState();

    if (dataManager.searchedData) {
        return dataManager.searchedData;
    }

    if (dataManager.filteredData) {
        return dataManager.filteredData;
    }

    return [];
}
